import { Feature, ColorFrom } from '@tencent/workbench';
import { ForeColorFeature as ToolbarForeColorFeature } from '@src/framework/workbench/ui/fore-color/fore-color-feature';
import { config } from '@src/framework/workbench/ui/fore-color/config';
import { getRgbaColor } from '@framework/workbench/drawer/utils/color-options';
import { MULTI } from '@src/js/constant';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { getTitleStyle, updateTitleStyle } from '@framework/workbench/drawer/ui/chart/common/font/util/title';
import { IChartTextProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';
import { ChartActionType } from '@src/slide/domain/ui-model/element-modeles/property/chart/constant';
import { ChartElementType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';
import { ColorSelectButton } from '@framework/workbench/drawer/components/color-select-button';
import React from 'react';
import {
    TDWVer5Type,
    TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

const DEFAULT_COLOR = new TDColor({
    rgbaStr: '#fefefe',
});

@Feature()
export class ChartFontColorFeature extends ToolbarForeColorFeature {
    id = config.id;
    config = config;

    public getColorValue = (): ITDColor => {
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return DEFAULT_COLOR;
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.getTitleFontColor(model);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        if (!element) return DEFAULT_COLOR;
        const value =  element.getTextFontColor();
        return value === MULTI ? DEFAULT_COLOR : value as ITDColor;
    };

    public handleColorChange = (value: ITDColor, from: ColorFrom | number) => {
        this.color = value;
        // this.saveRecentColorWithId(value);
        const model = this.getSelectModel() as IChartModel;
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const selecetdElementType = model.selectedElement.type;
        if (selecetdElementType === ChartElementType.TITLE) {
            return this.updateTitleFontColor(model, value);
        }
        const element = model.getSelectedElementProperty() as IChartTextProperty;
        element.updateFontStyle(ChartActionType.FONT_COLOR, value);
        this.getColorPickerManager()?.colorPickerTdwReport({
            color: value.srgb_color,
            colorPickerFrom: TDWVer6Type.COLOR_PICKER_DRAWER,
            colorGroupFrom: from,
            actionType: TDWVer5Type.COLOR_PICKER_FORE_FONT,
        });
    };

    public getColorSelectButton() {
        return <ColorSelectButton
            onColorChange={this.handleColorChange}
            value={this.getColorValue()}
        />;
    }

    private getTitleFontColor(model: IChartModel): ITDColor {
        const value = getTitleStyle(model, ChartActionType.FONT_COLOR);
        return value === MULTI ? DEFAULT_COLOR : value;
    }

    private updateTitleFontColor(model: IChartModel, value: ITDColor): void {
        updateTitleStyle(model, ChartActionType.FONT_COLOR, value);
    }
}
